import { Dropdown, Table } from "antd";
import React, { useEffect, useState } from "react";
import MaterialIcon from "material-icons-react";
import { useDispatch, useSelector } from "react-redux";
import svg38 from "../../../assets/svg/svg38.svg";
import FilterModal from "./FilterModal";
import withdrawal from "../../../assets/svg/withdrawalSvg.svg";
import { dateForHumans, timeAmPm } from "../../../utils";
import { Link, useNavigate } from "react-router-dom";
import InsideHeader from "../../../components/InsideHeader";
import SinglePaymentModal from "./single-payment/modal/SinglePaymentModal";
import { cleanDirectHeaderObj, cleanSinglePaymentObj, setDirectHeaderObj } from "../../../features/folder/folderSlice";
import BulkPaymentModal from "./bulk-payment/modal/BulkPaymentModal";
import svg27 from "../../../assets/svg/svg27.svg"; 
import eyeSvg from "../../../assets/svg/eye.svg"; 
import { fetchPaymentHeader } from "../../../features/dropdown/dropdownSlice";
import svg67 from "../../../assets/svg/svg67.svg";


function PendingDirectPaymentTable() { 
  const { paymentHeaderCount, paymentHeader } = useSelector((state) => state.dropdown);
  const { refetchKey} = useSelector((state) => state.folder);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [prodd, setProdd] = useState("");

  const [formData, setFormData] = useState({});
  const [filters, setFilters] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

 
  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchPaymentHeader());
    await setFilters([]);
  };

  const handleWithdraw = () => {
    navigate("/payment-page");
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchPaymentHeaderData(page, size) {
    await dispatch(fetchPaymentHeader({
      limit: size ?? pageSize,
      start: page ?? pageIndex,
      criteria: "phStatus",
      txtSearch: "notCompleted",
    }))
  }
   

  const [openSingle, setopenSingle] = useState(false);
  function handleCancelSingle() {
    setopenSingle(false);
  }
  async function handleOpenSingle() {
    await setopenSingle(true);
    await cleanSinglePaymentObjData();
  }

  const [openBulk, setopenBulk] = useState(false);
  function handleCancelBulk() {
    setopenBulk(false);
  }
  async function handleOpenBulk() {
    await setopenBulk(true);
    await cleanSinglePaymentObjData();
  }

  function cleanSinglePaymentObjData() {
    dispatch(cleanSinglePaymentObj());
  }

  
  const handleView=async()=>{
    await dispatch(setDirectHeaderObj(prodd))
    await navigate("/direct-payment-details")
  }

  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
         Details
        </Link>
      ),
    },
   
    {
      key: "1",
      label: (
        <Link
          // onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
         Delete
        </Link>
      ),
    },
   
  ];


  const columns = [
    {
      title: "Ph No",
      dataIndex: "phNo",
    },
    {
      title: "Created Date",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      dataIndex: "phCreatedDate",
    },
    {
      title: "Created Time",
      render: (item) => {
        return <div>{timeAmPm(item)}</div>;
      },
      dataIndex: "phCreatedTime",
    },
    {
      title: "Payee Type",
      dataIndex: "phPayeeType",
    },
    {
      title: "Description",
      dataIndex: "phPaymentDesc",
    }, 
    {
      title: "Status",
      dataIndex: "phStatus",
      render: (item) => {
        return (
          <div
          className={`${
            item === "PENDING_PAYMENT" || item == null ? "bg-[#FFB74D]" : item === "FAILED" ? "bg-[#FF4D4F]":item === "IN_COMPLETE" ? "bg-[#FFCC80]" : item === "PROCESSING" ? "bg-[#FFC107]": item === "COMPLETED" ?"bg-darkGreen" : null
          }  text-[#FFf] font-[700] inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },
    {
      title: "Ph Type",
      dataIndex: "phType",
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleOpenSingle}
          className="flex  text-[16px] font-sans  !text-lightBlack mb-2"
        >
          Single Payment
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenBulk}
          className="flex  text-[16px] font-sans  !text-lightBlack mb-2"
        >
          Bulk Payment
        </Link>
      ),
    },
  ];

  useEffect(() => {
    fetchPaymentHeaderData();
    dispatch(cleanDirectHeaderObj());
  }, []);

  useEffect(() => {
    if(refetchKey == 1){
      fetchPaymentHeaderData(); 
      dispatch(cleanDirectHeaderObj());
    } 
  }, [refetchKey]);
 
  return (
    <div className=""> 
      <div className="bg-white lg:px-10 px-3 rounded-[10px] mt-[1.25rem]">
        <div className="pt-[1.25rem] flex items-center justify-between">
          <div className="flex items-center">
            <span>
              {" "}
              <button
                onClick={showModal}
                type="button"
                className={`bg-transparent flex items-center gap-x-'1' ${
                  Object?.keys(formData)?.length > 0
                    ? "!text-[#5688E5]"
                    : "inherit"
                }`}
              >
                <MaterialIcon color="#141414" icon="filter_list" />
                Filters
              </button>
            </span>
            {Object?.keys(formData)?.length > 0 && (
              <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                :{Object?.keys(formData)?.length}
                <img src={svg38} alt="svg38" onClick={handleClearFilters} />
              </span>
            )}
          </div>

          <div  className="cursor-pointer" onClick={()=>fetchPaymentHeaderData(0,10)}>  
            <img src={svg67} alt="svg67"/>
         </div>

          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItemsQuickActions }}
            placement="bottom"
          >
            <div className="w-[250px]">
              <button className="cstm-btn flex gap-x-2" type="submit">
                <img src={withdrawal} alt={withdrawal} /> Initiate Payment
              </button>
            </div>
          </Dropdown>
        </div>

        <Table
          dataSource={paymentHeader}
          columns={columns}
          className="mt-[1.31rem]  mb-[10rem] w-full"
          scroll={{
            x: 800,
          }}
          pagination={{
            position: ["bottomCenter"],
            current: pageIndex + 1,
            total: paymentHeaderCount,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchPaymentHeaderData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          rowKey={(record) => record?.phId}
        />
      </div>

      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters} 
        setFilters={setFilters}
      />

      <SinglePaymentModal
        handleFetchData={fetchPaymentHeaderData}
        open={openSingle}
        setopenSingle={setopenSingle}
        handleCancel={handleCancelSingle}
      />
      <BulkPaymentModal
        handleFetchData={fetchPaymentHeaderData}
        open={openBulk}
        setopenSingle={setopenBulk}
        handleCancel={handleCancelBulk}
      />
    </div>
  );
}

export default PendingDirectPaymentTable;
